import React from "react";
import { APP_IDS } from "../constants/testIds";
import { formatUSD, TOTAL_TICKETS, TICKET_PRICE } from "../utils/formatters";

const MAX_REVENUE = TOTAL_TICKETS * TICKET_PRICE;

const Bar = ({ label, display, color, ratio, testId }) => {
  const pct = Math.max(0, Math.min(1, ratio)) * 100;
  return (
    <div className="flex items-center gap-3" data-testid={testId}>
      <span
        className="text-xs sm:text-sm font-semibold flex-shrink-0"
        style={{ color, width: 148, letterSpacing: "var(--tracking-normal)" }}
      >
        {label}
      </span>
      <div
        className="flex-1 h-6 sm:h-7 rounded-md relative overflow-hidden"
        style={{ background: "var(--surface-subtle)", boxShadow: "inset 0 0 0 1px var(--border-default)" }}
      >
        <div
          className="h-full rounded-md"
          style={{
            width: `${pct}%`,
            background: color,
            transition: "width var(--duration-slow) var(--ease-standard)",
          }}
          aria-hidden
        />
      </div>
      <span
        className="text-sm sm:text-base font-bold tabular-nums text-right flex-shrink-0"
        style={{ color, minWidth: 90 }}
      >
        {display}
      </span>
    </div>
  );
};

export const StatsBar = ({ stats }) => {
  const s = stats || { total: TOTAL_TICKETS, sold: 0, reserved: 0, funds_received: 0, pledged_revenue: 0, collected_revenue: 0 };
  const total = s.total || TOTAL_TICKETS;
  const collected = s.collected_revenue || 0;

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 py-4" aria-label="Raffle summary">
      <div
        className="px-4 sm:px-5 py-4 space-y-2.5"
        style={{
          background: "var(--surface-card)",
          border: "1px solid var(--border-default)",
          borderRadius: "var(--radius-lg)",
          boxShadow: "var(--shadow-card)",
        }}
      >
        <Bar
          testId={APP_IDS.statsTotal}
          label="Total Tickets"
          display={total}
          color="var(--brand-primary)"
          ratio={1}
        />
        <Bar
          testId="stat-funds-received"
          label="Funds Received"
          display={formatUSD(s.funds_received * TICKET_PRICE)}
          color="var(--status-funds-bg)"
          ratio={total ? s.funds_received / total : 0}
        />
        <Bar
          testId={APP_IDS.statsSold}
          label="Sold Pending"
          display={formatUSD(s.sold * TICKET_PRICE)}
          color="var(--status-sold-bg)"
          ratio={total ? s.sold / total : 0}
        />
        <Bar
          testId={APP_IDS.statsRevenue}
          label="Revenue"
          display={formatUSD(collected)}
          color="var(--brand-accent)"
          ratio={collected / MAX_REVENUE}
        />
      </div>
    </section>
  );
};
